import Qc2ConfigMatchPage from './Qc2ConfigMatchPage';

export default function DispatchQcConfigMatchPage() {
  return <Qc2ConfigMatchPage captureKind="dispatch-qc" />;
}
